export const getConfig = () => {
  if (typeof window === 'undefined') return undefined;

  return {
    ...window?.injectedConfiguratorSettings,
    ...window?.thdBreadcrumbInfo,
    env: window?.urlEnvironment,
    theHomeDepotComputedUrl: window?.injectedConfiguratorSettings?.theHomeDepotComputedUrl
  };
};

export const environment = {
  UspsShippingApiUrl: 'https://secure.shippingapis.com/ShippingAPI.dll?API=CityStateLookup',
  UspsShippingApiUserId: '824BLIND4334',
  StoreSearchService: 'https://www.homedepot.com/StoreSearchServices/v2/storesearch', // ?address=77042&radius=30`
};
